import { IReleaseNote } from "../types"

export const RELEASE_3_0_0: IReleaseNote = {
    status: "PAST",
    title: "v3.0.0",
    date: "11th May 2026",
    releaseType: "Major",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "We are excited to announce ENA Connect Direct 3.0.0 was released on the 11th May 2026. This is a major release, and it contains new features to make the site better, faster and more accurate. These notes outline the key changes.",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Threshold Management: DNO Thresholds will now be managed by an appointed Threshold Manager, allowing threshold changes to be made at your earliest convenience",
                "Application Amendment History: A new component has been added to the Application Summary page, allowing DNO users to view changes between the previous and resubmitted application",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Threshold Management:",
            bullets: [
                "A new DNO Threshold Management page has been added to Connect Direct, accessible from the DNO home screen navigation. A new DNO Threshold Manager role will also be added to the DNO Admin page, allowing authorised users to manage threshold configuration changes",
                "The Current DNO Configuration tab will be available as read-only for all DNO users and will display current DNO-level configuration and License Area thresholds in separate tables, showing threshold names, current values, and relevant license areas",
                "The Configuration Changes page will display a history of DNO configuration changes, from the Original Configuration through to each change request. Each change will be shown in an accordion section with a mandatory title, timestamp, status, and details of who raised and approved the change",
                "Threshold Managers can edit configuration values using a New Value column. When a change is submitted, a confirmation popup will display a summary of the changes and require a comment before the request moves to Pending Approval",
                "A second DNO Threshold Manager must approve or reject any pending change before it can take effect. Only one pending change request is allowed per DNO at a time, and a 10-minute lock will prevent other Threshold Managers from starting a new request while one is in progress",
            ],
        },
        {
            subtitle: "Application Amendment History:",
            bullets: [
                "The component will display amendments in chronological order, with the latest amendment shown at the top and the original application shown last. The original application will be the first version successfully passed to the DNO",
                "Where applicable, each accordion will also show the ENA Assessment Escalated Outcome, listing reasons why the amendment failed assessment",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Application Amendment History: Users will now receive amendment history information in the application payload, showing the changes between the previous and resubmitted application",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Application Amendment History:",
            bullets: [
                "Users will now receive amendment history information in the application payload. Amendments will be provided in chronological order, with the latest amendment first and the original application last. The original application will be the first version successfully passed to the DNO",
                "Where applicable, the payload will also include the ENA Assessment Escalated Outcome, listing the reasons why an amendment failed assessment",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
